import { createTheme } from '@mui/material/styles';

// El mismo tema que NARA CRM (`/root/nara-crm/frontend/src/main.jsx`): las
// aplicaciones de NARA se tienen que sentir como una sola. Si se cambia aquí,
// se cambia allá. La paleta es sobria a propósito: el color se reserva para
// lo que significa algo —un estado, un saldo vencido— y no para decorar.
const theme = createTheme({
  palette: {
    primary: { main: '#1e3a5f' },
    secondary: { main: '#0891b2' },
    success: { main: '#16a34a' },
    warning: { main: '#f59e0b' },
    error: { main: '#dc2626' },
    background: { default: '#f1f5f9', paper: '#ffffff' },
    text: { primary: '#0f172a', secondary: '#64748b' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiTableCell: { styleOverrides: { root: { fontSize: 13 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    // Antes, como en el CRM, las tarjetas llevaban borde y no sombra.
    MuiCard: {
      defaultProps: { variant: 'outlined' },
      // Medidas de la skill de diseño (2026-11-01, `estilos/tarjeta.js`):
      // radio 6, sin borde ni sombra; el blanco sobre el fondo gris ya las separa.
      styleOverrides: { root: { borderRadius: 6, border: 'none', boxShadow: 'none' } },
    },
    // Relleno compacto: 8 px en celular y 10 en computador (MUI traía 16 y 24 abajo).
    MuiCardContent: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          padding: 8, '&:last-child': { paddingBottom: 8 },
          [t.breakpoints.up('md')]: { padding: 10, '&:last-child': { paddingBottom: 10 } },
        }),
      },
    },
    // Modales (decidido por Raúl el 2026-10-28, igual que en nara-ui):
    // compactos y con el encabezado del color del menú lateral de ESTA
    // aplicación, título y X en blanco.
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 14, overflow: 'hidden' }, paperFullScreen: { borderRadius: 0 } },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          background: '#1e3a5f', color: '#ffffff', padding: '12px 56px 12px 20px',
          fontSize: 15, fontWeight: 800, lineHeight: 1.3, position: 'relative',
          '& .MuiTypography-root': { color: 'inherit' },
          '& .MuiTypography-body2, & .MuiTypography-root ~ .MuiTypography-root': { color: '#cbd5e1', fontWeight: 400 },
          '& .MuiIconButton-root': {
            color: '#ffffff', position: 'absolute', top: 6, right: 6,
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.14)' },
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: { padding: '16px 20px', '.MuiDialogTitle-root + &': { paddingTop: 16 } },
        dividers: { borderTop: 'none', borderBottom: '1px solid #e2e8f0' },
      },
    },
    MuiDialogActions: { styleOverrides: { root: { padding: '10px 20px 14px', gap: 8 } } },
  },
});

export default theme;
